import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';

import { FORTA_BLUE } from '../../../../../utils/colors';
import LinkedClaimItem from './LinkedClaimItem';

import type { RootState } from '../../../../../store';

function LinkedClaims() {
  const { current: claim } = useSelector((state: RootState) => state.claims);

  if (!claim) return null;
  const historyOfClaims = claim
    ? [
        ...claim.ancestors,
        {
          clearing_house_claim_id: claim?.clearing_house_claim_id,
          id: claim?.id,
          status: claim?.status,
          secondary_status: claim?.secondary_status,
          total_charge: claim?.form_1500_data.total_charge,
        },
        ...claim.descendants,
      ]
    : [];
  return claim?.ancestors?.length || claim?.descendants?.length ? (
    <Box mb={3} data-testid="coLinkedClaimsContainer">
      <Typography textAlign="left" fontSize={21} color={FORTA_BLUE.primary} mb={1}>
        Linked to claim
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
        {historyOfClaims.map((item, index) =>
          item.id == null ? null : (
            <LinkedClaimItem
              dataTestId={`coLinkedClaim-${index + 1}`}
              key={item.id}
              index={index + 1}
              isOriginalClaim={index === 0}
              isCurrentClaim={item.id === claim?.id}
              claimId={item.id}
              secondaryStatus={item.secondary_status}
            />
          ),
        )}
      </Box>
    </Box>
  ) : null;
}
export default LinkedClaims;
